import VendorBomContainer from '@components/containers/vendorBom';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

/** The recipes this site works to — read-only; the brand owns them. */
const VendorBom: FC = () => (
    <VendorLayout>
        <VendorBomContainer />
    </VendorLayout>
);

export default VendorBom;
